import { render, staticRenderFns } from "./contactsPeople.vue?vue&type=template&id=fbeca510&"
import script from "./contactsPeople.vue?vue&type=script&lang=js&"
export * from "./contactsPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports